<template>
  <p class="infoMessage">
    <information-icon title="" /><span class="message" v-html="text" />
  </p>
</template>

<script>
import InformationIcon from 'vue-material-design-icons/Information.vue';

export default {
  name: "InfoMessage",
  components: {
    InformationIcon
  },
  props: {
    text: String
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"

p
  display: flex
  align-items: flex-start
  color: $gray-3
  margin: 0.25em 0

  .information-icon
    margin: 0 0.4em 0 0
    font-size: 0.9em
    



</style>